import "./tags.css";
import React, { useState } from "react";
import ReactTags from "react-tag-autocomplete";
import { useSuggestions } from "./useSuggestions";

export function AutoComplete(props = {}) {
  return props.isServer ? <AutoCompleteServer {...props} /> : <AutoCompleteClient {...props} />;
}

function AutoCompleteClient(props = {}) {
  const [tags, setTags] = useState(props.initialTags);
  const suggestions = props.options ? props.options.filter((i) => !tags.includes(i)) : [];
  return (
    <AutoCompleteMerge
      tags={tags}
      setTags={setTags}
      suggestions={suggestions}
      minQueryLength={props.minQueryLength || 0}
      {...props}
    />
  );
}

function AutoCompleteServer(props = {}) {
  const [tags, setTags] = useState(props.initialTags);
  const [query, setQuery] = useState();
  const suggestions = useSuggestions(query || " ", props.filter, tags);
  const handleInputChange = (query) => setQuery(query);
  return (
    <AutoCompleteMerge tags={tags} setTags={setTags} onInput={handleInputChange} suggestions={suggestions} {...props} />
  );
}

function AutoCompleteMerge({
  tags,
  name,
  datafield = "",
  placeholder = "Please type here...",
  noSuggestions = "No suggestions available",
  options = [],
  minQueryLength = 2,
  onInput,
  setTags,
  suggestions,
}) {
  const handleDelete = (i) => setTags(tags.filter((item, index) => index !== i));
  const handleAddition = (tag) => {
    const selectedSuggestion = suggestions.find((item) => item.id === tag.id);
    if (tags.includes(selectedSuggestion)) return null;
    return setTags(tags.filter((t) => t.id).concat(selectedSuggestion));
  };

  return (
    <ReactTags
      tags={tags}
      minQueryLength={minQueryLength}
      maxSuggestionsLength={10}
      suggestions={suggestions}
      onDelete={handleDelete}
      onAddition={handleAddition}
      onInput={onInput}
      placeholder={placeholder}
      noSuggestionsText={noSuggestions}
      suggestionsFilter={() => true}
      inputAttributes={{
        name,
        datafield,
        autoComplete: "off",
        datavalue: tags.map((i) => i.id).join("|"),
        datalang: tags.map((i) => i.lang).join("|"),
        total: options.length,
        datainputtype: "autocomplete",
      }}
    />
  );
}
